// Only short, single-line calculations belong in the three-column layout.
export function isCompactCalculation(node) {
  const json = node.toJSON ? node.toJSON() : node;
  if (json.type !== 'questionBlock' || json.content?.length !== 1 || json.content[0].type !== 'paragraph') return false;
  const inline = json.content[0].content || [];
  if (inline.some(n => !['text', 'mathInline', 'answerBox'].includes(n.type))) return false;
  const text = inline.map(n => n.text || n.attrs?.latex || '').join(' ');
  return text.length <= 85 && text.split(/\s+/).length <= 14 && /[+−×÷=]|\\(?:times|div|frac)/.test(text)
    && !/\\(?:begin|dfrac|sqrt)|\\frac.*\\frac/.test(text);
}
export function arrangeQuestionRows(blocks, makeRow, enabled) {
  const flat = blocks.flatMap(node => node.type.name === 'questionRow' ? Array.from({ length: node.childCount }, (_, i) => node.child(i)) : [node]);
  if (!enabled) return flat;
  const output = []; let pending = [];
  const flush = () => { if (pending.length) output.push(pending.length === 1 ? pending[0] : makeRow(pending)); pending = []; };
  flat.forEach(node => { if (isCompactCalculation(node)) { pending.push(node); if (pending.length === 3) flush(); } else { flush(); output.push(node); } });
  flush(); return output;
}
